import { SVGProps } from 'react';

export const ArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9637 8.73629L9.89997 6.67259V14.4H8.09997V6.67259L6.03627 8.73629L4.76367 7.46369L8.99997 3.22739L13.2363 7.46369L11.9637 8.73629ZM9 0C4.0374 0 0 4.0374 0 9C0 13.9626 4.0374 18 9 18C13.9626 18 18 13.9626 18 9C18 4.0374 13.9626 0 9 0Z"
      fill="currentColor"
    />
  </svg>
);
